import { TourDefinition } from './types';

export const TOURS: Record<string, TourDefinition> = {
  dashboard: {
    id: 'dashboard',
    // 24/09: a ordem segue a tela nova (o método em cima, a Sarah logo abaixo).
    steps: [
      {
        id: 'magic-words',
        targetSelector: '[data-tour="magic-words"]',
        title: 'The 3 Magic Words',
        description: 'The two short books that teach the three phrases from the video. Start with the first one.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'sarah-chat',
        targetSelector: '[data-tour="sarah-chat"]',
        title: 'Ask Sarah',
        description: 'Tell Sarah what\'s happening. She\'ll give you the exact words to say, in seconds.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        // 22/09: para todo mundo (tudo vem com a compra principal).
        id: 'purchases',
        targetSelector: '[data-tour="purchases"]',
        title: 'Also included',
        description: 'Three more programs are included: The Grandma Code, The Screen Switch and The Calm Mom Code.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'library',
        targetSelector: '[data-tour="library"]',
        // 24/09: o card abre o livro mais novo; todos os livros moram na aba Books.
        title: 'Our newest book',
        description: 'Each new book shows up here first. All the books are in the Books tab at the bottom.',
        position: 'top',
        spotlightPadding: 8,
      },
      {
        id: 'child-profile',
        targetSelector: '[data-tour="child-profile"]',
        title: 'Your Child\'s Profile',
        // 22/09: prometia "tap to ... add a new one", e o selo não adiciona; com
        // uma criança só, ele nem é tocável (auditoria 07).
        description: 'Sarah shapes her advice around this child. With more than one child, tap here to switch.',
        position: 'bottom',
        spotlightPadding: 8,
      },
    ],
  },
  scripts: {
    id: 'scripts',
    steps: [
      {
        id: 'search',
        targetSelector: '[data-tour="scripts-search"]',
        title: 'Search Phrases',
        description: 'Type what is happening, like "bedtime" or "hitting", to find the right phrase.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'filters',
        targetSelector: '[data-tour="scripts-filters"]',
        title: 'Filter by Category',
        description: 'Tap a topic, like Bedtime or Screens, to see only those phrases. Tap it again to see them all.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'script-card',
        targetSelector: '[data-tour="script-card"]',
        title: 'Phrase Cards',
        description: 'Each card is one situation, with the words to say. Tap one to open it.',
        position: 'bottom',
        spotlightPadding: 8,
      },
    ],
  },
  ebook_reader: {
    id: 'ebook_reader',
    steps: [
      {
        id: 'toc',
        targetSelector: '[data-tour="ebook-toc"]',
        title: 'Table of Contents',
        description: 'Jump to any chapter instantly. Track your progress as you read.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'search',
        targetSelector: '[data-tour="ebook-search"]',
        title: 'Search',
        description: 'Find any word or phrase in the entire book.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'notes',
        targetSelector: '[data-tour="ebook-notes"]',
        title: 'Personal Notes',
        description: 'Add your own notes while reading. They\'re saved automatically.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      {
        id: 'settings',
        targetSelector: '[data-tour="ebook-settings"]',
        title: 'Reading Settings',
        description: 'Adjust font size, toggle dark mode, and bookmark chapters.',
        position: 'bottom',
        spotlightPadding: 8,
      },
    ],
  },
  expert_chat: {
    id: 'expert_chat',
    steps: [
      {
        id: 'expert-profile',
        targetSelector: '[data-tour="expert-profile"]',
        title: 'Meet Sarah',
        description: 'Your parenting coach. She knows your children\'s profiles and tailors every response.',
        position: 'bottom',
        spotlightPadding: 12,
      },
      {
        id: 'child-selector',
        targetSelector: '[data-tour="chat-child-selector"]',
        title: 'Pick Which Child You\'re Asking About',
        description: 'Got more than one kid? Tap here to switch which child Sarah is focused on. Each conversation stays tied to that child\'s age, profile, and history.',
        position: 'bottom',
        spotlightPadding: 8,
      },
      // 25/09: os passos "Always Available" (pílula Online) e "100% Confidential"
      // saíram junto com os selos do cabeçalho.
      {
        id: 'message-input',
        targetSelector: '[data-tour="message-input"]',
        title: 'Tell Sarah What\'s Going On',
        description: 'Describe the situation and she\'ll give you your 3 Magic Words — exactly what to say right now.',
        position: 'top',
        spotlightPadding: 12,
      },
    ],
  },
};
